/*====================================
    商品加工預計工作日 Factory
    
    商品預計出貨日會因為加工而變長（與後端 ProcessDeliveryDate.java 同步）

    Author : Gray
    建立時間 : 2017 / 07 / 25
    最後更新時間 : 2018 / 12 / 14
====================================*/

window.InifECShared.factory("ProductDeliveryService", ['$q', '$http', 'ProductUtil', 'ProductService', function($q, $http, ProductUtil, ProductService) {

    var factory = this;

    var PdtSpecProps = ProductUtil.PdtSpecProps; // 商品規格所有欄位
    var pdtSpecClassMap = {};

    // --------------------------------
    // 取得加工時間總和
    //
    // 回傳：幾天（int）
    // --------------------------------
    var getProcessDelivery = function(pdtClass, processList) {

        var delivery = 0;

        if(!Array.isArray(processList) || processList.length == 0) {
            return delivery;
        }

        var pdtSpecClass = pdtSpecClassMap[pdtClass];

        if(!pdtSpecClass || !pdtSpecClass.processDetail || !pdtSpecClass.processDetail.deliveryMap) {
            return delivery;
        }

        var deliveryMap = pdtSpecClass.processDetail.deliveryMap;

        for(var i = 0; i < processList.length; i++) {
            var _process = processList[i].key;
            var processDelivery = deliveryMap[_process];

            if (processDelivery && processDelivery > 0) {
                delivery += processDelivery;
            }
        }

        return delivery;
    }

    // --------------------------------
    // 取得規格時間總和
    //
    // 回傳：幾天（int）
    // --------------------------------
    var getSpecDelivery = function(pdtClass, spec) {

        var delivery = 0;

        if(!pdtClass || !spec || !spec.specProps) {
            return delivery;
        }

        return delivery;
    }

    // --------------------------------
    // 檢查是否已讀取資料了
    // --------------------------------
    var getIsLoaded = function() {

        return factory.isLoaded;
    }

    // --------------------------------
    // 載入資料
    // --------------------------------
    var loadInfo = function() {

        var defer = $q.defer();

        if(factory.isLoaded) {
            defer.resolve(true);
        } else {
            return initPdtSpecClassMap(defer);
        }

        return defer.promise;
    }

    /**
     *
     * [DIFFERENT] 前後台審稿手機版行為不一樣的function 
     * 
     */

    // --------------------------------
    // initPdtSpecClassMap
    // --------------------------------
    var initPdtSpecClassMap = function(defer) {

        ProductService.getProductClassListLite().then(function(result) {
            if(result && result.pdtSpecClassMap) {
                pdtSpecClassMap = result.pdtSpecClassMap;
                factory.isLoaded = true;
            }
            defer.resolve(true);
        }, function(error) {
            defer.resolve(true);
        });

        return defer.promise;
    }

    // --------------------------------
    // [private] 初始化
    // --------------------------------
    var init = function() {

        loadInfo();
    }

    //==========================
    //  Members
    //==========================
    factory.isLoaded = false;

    //==========================
    //  Methods
    //==========================
    factory.getIsLoaded = getIsLoaded; // 檢查是否已讀取資料了
    factory.loadInfo = loadInfo; // 載入資料
    factory.getProcessDelivery = getProcessDelivery; // 取得加工時間總和
    factory.getSpecDelivery = getSpecDelivery; // 取得規格時間總和

    //==========================
    //  Init
    //==========================
    init();

    return factory;
}]);